"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable no-console */
/* eslint-disable no-undef */
/**
 * Logs a Deprecation Warning to the console for v1 components.
 * @static
 * @function deprecationWarningLog
 * @param {Object} [deprecationWarningContent={}] - The content of the deprecation warning.
 * @param {String} [deprecationWarningContent.componentName=null] - The name of the original component.
 * @param {string} [deprecationWarningContent.newComponentName=null] - The name of the new component if the name is significantly different than the original (ie. 'Panel' becomes 'Accordion').
 * @param {Array} [deprecationWarningContent.changes=null] - The array of changes to the component.
 * @example
 * const deprecationWarningContent = {
 * name: 'Old Component',
    newName: 'New Component',
    changes: [
        'Prop 1 changed to Prop A',
        'Prop 2 changed to Prop B',
    ],
 * };
 *
 * deprecate(deprecationWarningContent);
 * @returns {void}
 */

const DEPRECATION_LIST = [];
const deprecate = ({
  name,
  newName,
  changes
}) => {
  if (process.env.NODE_ENV !== 'development' || DEPRECATION_LIST.includes(name)) {
    return;
  }
  console.groupCollapsed(`fe-ui v1 ${name} Deprecation Warning: `);
  console.log(`This component, ${name}, is now deprecated. Please use the v2 ${newName ? newName : name} instead.`);
  changes.forEach(change => console.log(change));
  console.groupEnd(`fe-ui v1 ${name} Deprecation Warning: `);
};
var _default = exports.default = deprecate;